module.exports = __webpack_public_path__ + "static/media/50.8dcc2e09.jpg";